
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"6","y":"18","width":"12","height":"4","rx":"2"}}),_c('path',{attrs:{"d":"M10.95 8.298c.173-.107.3-.286.3-.49V2.424a.5.5 0 00-.895-.307l-4.34 5.579a2.5 2.5 0 00-.213 2.748l2.801 5.042a1 1 0 00.874.514h5.046a1 1 0 00.874-.514l2.8-5.042a2.5 2.5 0 00-.212-2.748l-4.34-5.579a.5.5 0 00-.895.307v5.384c0 .204.127.383.3.49A1.999 1.999 0 0112 12a2 2 0 01-1.05-3.702z"}})])
          )
        }
      }
    